export { SharedDocumentsDataAccessDocumentsModule } from './lib/shared-documents-data-access-documents.module';
export { DocumentsDataModule } from './lib/documents-data/documents-data.module';
export { DocumentsDataService } from './lib/documents-data/documents-data.service';
export { DocumentType } from './lib/models/document-type';
export { SendDocumentResponse } from './lib/models/send-document-response';
export { DriverDocument } from './lib/models/driver-document';
